"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var owa_options_core_1 = require("owa-options-core");
var store_1 = require("../store/store");
var owa_session_store_1 = require("owa-session-store");
var legacy_1 = require("satcheljs/lib/legacy");
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
    userOptions: function () { return owa_session_store_1.getUserConfiguration().UserOptions; },
})(legacy_1.action('saveLinkPreviewOption')(function saveLinkPreviewOption(state) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var optionState, userOptions;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    optionState = state.optionState, userOptions = state.userOptions;
                    userOptions.LinkPreviewEnabled = optionState.isEnabled;
                    return [4 /*yield*/, owa_options_core_1.updateUserConfiguration([
                            {
                                propertyName: 'LinkPreviewEnabled',
                                propertyType: 'Boolean',
                                propertyValue: "" + userOptions.LinkPreviewEnabled,
                            },
                        ])];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}));
//# sourceMappingURL=saveLinkPreviewOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-link-preview-option/lib/actions/saveLinkPreviewOption.js
// module id = 5145
// module chunks = 2